import React from "react";

import { api } from "src/common/utils/api";
import { AuthType } from "src/features/auth";
import { useCreateGenericError } from "src/features/notifications";

export function useAuthType(
	email: string
): readonly [boolean, AuthType | null] {
	const createGenericError = useCreateGenericError();

	const [isLoading, setLoading] = React.useState(true);
	const [authType, setAuthType] = React.useState<AuthType | null>(null);

	React.useEffect(() => {
		const fetch = async (): Promise<void> => {
			setLoading(true);
			try {
				const { data } = await api.post<AuthType>("/authflow/type", {
					email
				});
				setLoading(false);
				setAuthType(data);
			} catch {
				setLoading(false);
				createGenericError();
			}
		};
		fetch();
	}, [email, createGenericError]);

	return [isLoading, authType];
}
